import { Link } from "@mui/material";
import LinkBehavior from "../../theme/LinkBehavior";

export default function RouterLink(props: any) {
    const {children, ...other} = props;
    return (<Link component={LinkBehavior} {...other}>{children}</Link>);
}